import React, { ReactNode } from 'react'
import { Link } from 'react-router'

function IssueIdLink({
    issue,
    children,
}: {
    children: ReactNode
    issue: { issueId: string } | { issue: { issueId: string } }
}) {
    const i = issue.issue || issue
    return <Link to={`/issues/${i.issueId}`}>{children}</Link>
}

export default IssueIdLink
